export default {
  yellow: (input: string) => input
}
